import React from 'react';
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import classNames from 'classnames';
import {Cancel} from "@material-ui/icons";
import {components} from 'react-select';
import './suggestions.css'
import {FormControl, FormHelperText, Icon, Tooltip} from "@material-ui/core";
import SortableItem from "./Sortable/SortableItem";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import IconButton from "@material-ui/core/IconButton";

export const InputComponent = ({inputRef, ...props}) => {
    return <div ref={inputRef} {...props} />;
};

export const Control = (props) => {
    if (props.selectProps.setMenuState) {
        props.selectProps.setMenuState(props.selectProps.menuIsOpen)
    }
    return (
        <FormControl fullWidth={props.selectProps.fullWidth}>
            <TextField
                variant={props.selectProps.variant}
                className={props.selectProps.isWithStyles ? 'horizontal-fields-table' : 'form-dynamic'}
                fullWidth={props.selectProps.fullWidth}
                label={props.selectProps.label}
                error={props.selectProps.error}
                InputLabelProps={{
                    shrink: true,
                    style: {backgroundColor: '#fff'}
                }}
                InputProps={{
                    inputComponent: InputComponent,
                    disableUnderline: true,
                    inputProps: {
                        variant: props.variant,
                        autoFocus: props.autoFocus,
                        className: props.selectProps.classes.input,
                        style: {
                            height: 'auto',
                            padding: props.selectProps.isWithStyles ? '0px 3px 0px 3px' : '0px 3px 0px 3px',
                            width: props.selectProps.width || (!props.selectProps.fullWidth && '195px'),
                            margin: props.selectProps.margin,
                        },
                        ref: props.innerRef,
                        children: props.children,
                        ...props.innerProps,
                    },
                }}
            />
            {props.selectProps.error && (
                <FormHelperText error variant={"outlined"} style={{margin: 0}}>
                    {props.selectProps.label}
                </FormHelperText>)}
        </FormControl>
    );
};

export const Option = (props) => {
    return (
        <MenuItem
            buttonRef={props.innerRef}
            selected={props.isFocused}
            component="div"
            style={{
                paddingBottom: 2,
                paddingTop: 2,
                fontWeight: props.isSelected ? 500 : 400,
            }}
            {...props.innerProps}
        >
            {props.children}
        </MenuItem>
    );
};

export const OptionIcons = (props) => {

    return (
        <MenuItem
            buttonRef={props.innerRef}
            selected={props.isFocused}
            component="div"
            style={{
                paddingBottom: 2,
                paddingTop: 2,
                fontWeight: props.isSelected ? 500 : 400,
            }}
            {...props.innerProps}
        >
            <Icon style={{}}>{props.children}</Icon>
            <span style={{marginLeft: 20}}>{props.children}</span>
        </MenuItem>
    )
};

export const OptionWrapper = (props) => {
    let columns = [];
    for (let i = 0; i < props.selectProps.options.length; i++) {
        if (i === 0) {
            columns = props.selectProps.options[0].columns
        }
    }
    return (
        <components.MenuList {...props}>
            <div className={"table-row wrapper header"}>
                <div className={"wrapper text-4"}>
                    <div className={"wrapper text-2"}>
                        {columns && columns.map((element, index) => {
                            return (
                                <div key={index} className={"text header-values"}>
                                    <span
                                        style={(index === 0) ? {paddingLeft: 10} : {padding: 0}}>{element.label}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            {props.children}
        </components.MenuList>
    )
};

export const OptionTable = (props) => {
    let columns = [];
    for (let i = 0; i < props.selectProps.options.length; i++) {
        if (i === 0) {
            columns = props.selectProps.options[0].columns
        }
    }
    return (
        <components.Option {...props}>
            <div {...props.innerProps} style={props.isFocused ? {background: '#efefe8'} : {background: 'white'}}
                 className={"table-row wrapper"}>
                <div className={"wrapper text-4"}>
                    <div className={"wrapper text-2"}>
                        {columns ? columns.map((element, index) => {
                            const node = document.getElementById(`row${props.data.value[element.name]}`);
                            return (
                                <div id={`row${props.data.value[element.name]}`} key={index}
                                     className={"text values-row"}>
                                    <Tooltip open={props.isFocused}
                                             title={node ? node.offsetWidth < node.scrollWidth ? props.data.value[element.name] : '' : ''}>
                                    <span
                                        style={(index === 0) ? {paddingLeft: 10} : {padding: 0}}>{props.data.value[element.name]}</span>
                                    </Tooltip>

                                </div>
                            )
                        }) : <div className={"text values-row"}>
                            <span style={{paddingLeft: 10}}>{props.selectProps.options[0].label}</span>
                        </div>}
                    </div>
                </div>
            </div>
        </components.Option>
    );
};
export const Placeholder = (props) => {
    return (
        <Typography
            color="textSecondary"
            {...props.innerProps}
            className={props.selectProps.classes.placeholder}
        >
            {props.children}
        </Typography>
    );
};

export const ValueContainer = (props) => {
    return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
};

export const ValueContainerIcons = (props) => {
    return <div className={props.selectProps.classes.valueContainer}>
        <Icon>{props.children}</Icon>
        <span style={{marginLeft: 10}}>{props.children}</span>
    </div>;
};

export const valueRendererSortable = (props) => {
    return (
        <SortableItem
            index={props.data.index}
            element={props.selectProps.element}
            parent={props.selectProps.path}
            valueIndex={props.selectProps.valueIndex}
            className="sortable-item"
            swapItems={props.selectProps.swapItems}
        >
            <Chip
                style={{height: 27}}
                tabIndex={-1}
                label={props.children}
                className={classNames(props.selectProps.classes.chip, {
                    [props.selectProps.classes.chipFocused]: props.isFocused,
                })}
                onDelete={props.removeProps.onClick}
                deleteIcon={<Cancel {...props.removeProps} />}
            />
        </SortableItem>
    );
};

export const MultiValue = (props) => {
    return (
        <Chip
            tabIndex={-1}
            style={{height: 27}}
            label={props.children}
            className={classNames(props.selectProps.classes.chip, {
                [props.selectProps.classes.chipFocused]: props.isFocused,
            })}
            onDelete={props.removeProps.onClick}
            deleteIcon={<Cancel {...props.removeProps} />}
        />
    );
};

export const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <IconButton style={{padding: 0}}>
                <ArrowDropDownIcon
                    style={{
                        color: 'rgba(0, 0, 0, 0.54)',
                        transform: props.selectProps.menuIsOpen === true ? 'rotate(180deg)' : "rotate(0deg)"
                    }}/>
            </IconButton>
        </components.DropdownIndicator>
    );
};

export const Menu = (props) => {
    return (
        <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
            {props.children}
        </Paper>
    );
};

export const MenuSimpleArr = (props) => {
    return (
        <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
            <span style={{display: 'none'}}>{props.children}</span>
        </Paper>
    );
};

